import { render } from "./RelatorioAeracao.vue?vue&type=template&id=683abb4d&scoped=true"
import script from "./RelatorioAeracao.vue?vue&type=script&lang=js"
export * from "./RelatorioAeracao.vue?vue&type=script&lang=js"

import "./RelatorioAeracao.vue?vue&type=style&index=0&id=683abb4d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683abb4d"]])

export default __exports__